import React, {useState} from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederInntektskalkulatorDto from '../Models/VeilederInntektskalkulatorDto';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { connect } from 'react-redux';
import * as ValgTypes from '../Store/Valg/Types';
import Valg from '../../Shared/Scripts/Models/Valg';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import * as Ids from '../Models/Ids';
import { VeilederInntektskalkulatorAppState } from '../Store';
import * as Utregninger from '../Utilities/Utregninger';

interface BoksOwnProps {
    valg: ValgTypes.ValgState,
    locale: string,
    valuta?: string | null,
    onInputChange: any;
}

type BoksAProps = BoksOwnProps & MapStateToProps & {};

const ResultatComponent = (props: BoksAProps): JSX.Element => {
    const { epiContext } = props;
    const [visModal, setVisModal] = useState(false);
    const [inntekt, setInntekt] = useState("");

    function onModalLenkeClick(): void {
        setVisModal(true);
    }

    function onModalLukkClick(): void {
        setVisModal(false);
    }

    function inntektHandler(e: React.SyntheticEvent<HTMLInputElement>): void {
        
        let stringVal: string = e.currentTarget.value.replace(/[^0-9]/g,''); 

        if(stringVal.length > 7)
            return;

        if(stringVal === "") {
            setInntekt("");
            return;
        }

        let formatertVerdi: string = Utregninger.formatNumber(stringVal, props.locale);
        setInntekt(formatertVerdi);
    }

    function enterHandler(e: React.KeyboardEvent<HTMLInputElement>): void {
        if (e.key === 'Enter') {
            let valg: Valg<string> = { id: 'Inntekt', displayValue: 'Inntekt', value: inntekt };
            props.onInputChange(valg);
        }
    }

    function knappKlikk(e: React.SyntheticEvent<HTMLButtonElement>): void {
        let i: string = inntekt;
        if (inntekt === "") {
            setInntekt("0");
            i = "0";
        }

        let valg: Valg<string> = { id: 'Inntekt', displayValue: 'Inntekt', value: i };
        props.onInputChange(valg);
    }

    return (
        <div id={Ids.boksA} className="c-veileder__panel c-veileder__panel--input-white">
            <div className="c-veileder__content c-veileder__content--header">
                <h3 className="c-veileder__tittel">{contentResolver(epiContext, 'boks1Overskrift')}</h3>
            </div>
            <div className="c-veileder__content">
                <div className="c-veileder__undertittel">{contentResolver(epiContext, 'boks1UnderOverskrift')}</div>
            </div>
            <div className="c-veileder__content">
                {contentResolver(epiContext, 'boks1Ingress')}
            </div>
            <div className="c-veileder__content">
                <p>
                    <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine c-veileder--div-spacer" onClick={onModalLenkeClick}>
                        {contentResolver(epiContext, 'modalLenketekst')}
                    </button>
                    <ModalCompontent
                        isOpen={visModal}
                        onRequestClose={onModalLukkClick}
                        ariaCloseText={resolveRawText(epiContext, 'modalLukkTekst')}
                    >
                        <ArticleContentComponent
                            headerinnhold={contentResolver(epiContext, 'modalTittel')}
                            contentinnhold={contentResolver(epiContext, 'modalTekst')}
                        />
                    </ModalCompontent>
                </p>
            </div>
            <div className="c-veileder__content c-veileder__content--inputarea">
                <div className="c-veileder__inputomrade  c-veileder--mini-twocolumn-input-container c-veileder--tekstomraade">
                    <div className="c-veileder--mini-twocolumn-input-item">
                        <label className="c-veileder__undersporsmal" htmlFor={Ids.boksA + "-input"}>
                            {contentResolver(epiContext, 'boks1InntektLedetekst')}
                        </label>
                    </div>
                    <div className="c-veileder--mini-twocolumn-input-item">
                        <div className="c-number-input c-number-input--big ">
                            <input value={inntekt} onKeyUp={enterHandler} onChange={inntektHandler} id={Ids.boksA + "-input"} type="text" className="c-number-input__input" />
                            <div className="c-number-input__postfix"><span>{props.valuta}</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="c-veileder__content c-veileder--kontainer-center">
                <div className="c-knapp--container">
                    <button onClick={knappKlikk}  className={"c-knapp c-knapp--cta c-knapp--primary"}>{contentResolver(epiContext, 'boks1Knappetekst')}</button>
                </div>
            </div>
        </div>
    );
};

interface MapStateToProps {
    epiContext: EpiContext<VeilederInntektskalkulatorDto>;
}

export default connect(
    (state: VeilederInntektskalkulatorAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
)(ResultatComponent);